import { api } from '../api';

const getCustomerVousList = async ({customerId, groupId = 3}) => {
    const response = await api({
        url: `CustomerVous/GetList`,
        method: 'GET',
        headers: {
            'x-skip-loader': true,
        },
        params: {
            CustomerId: customerId,
            GroupId: groupId,
        },
    });
    return response.data;
};

const getVehicleDeviceTypeList = async ({customerId, vouId}) => {
    const response = await api({
        url: `VehicleDeviceTypes/GetList`,
        method: 'GET',
        headers: {
            'x-skip-loader': true,
        },
        params: {
            CustomerId: customerId,
            VouId: vouId,
        },
    });
    return response.data;
};

const addCarTypeServices = {
    getCustomerVousList,
    getVehicleDeviceTypeList
};

export default addCarTypeServices;